<template>
    <router-view />
</template>

<script>
import './style.css'

export default {
    name: 'catalog-index'
}
</script>
